<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>

    <div class="card-body">

      <div class="p-5 " style="background-color: #EFEFEF">
        <p class="bold" style="font-size:  20px">Inserisci l'indirizzo della ricerca</p>
        <h6 class=""><strong>**<u>Non ricaricare la pagina durante la ricerca, potrà richiedere qualche minuto</u>**</strong></h6>
        <div class="pt-5">


          <div style="display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); column-gap: 10px;">

          <city @update:comune="comune = $event" @update:provincia="prov = $event"></city>

            <div>
              <input v-model="indirizzo" type="text" placeholder="Inserisci l'indirizzo" class="form-control w-75"  >
              <h6 class="mt-1 text-black"><strong>*Ometti "via", "viale", "piazza" etc. <br> Utilizza le lettere maiuscole ove necessario</strong></h6>
             </div>

          </div>

          <div class="form-inline -pt-5">
            <span class="mr-2">dal civico n°</span> <input type="number" v-model="startCiv" class="mr-3 form-control"
                                                           style="width: 70px">
            <span class="mr-2">al civico n°</span> <input v-model="endCiv" type="number" class="mr-3 form-control" style="width: 70px">
            <button :disabled="searching" type="button" @click="getAddress()"
                    class="text-center mt-2 btn btn-success abtg__btn-third shadow-none abtg-button-big">Inizia la ricerca
            </button>
          </div>

          <h4 class="mt-2 bold">{{errorCom}}</h4>
        </div>


        <div v-if="searching" class="d-flex mt-5">
          <h5 class="mr-2 bold">Ricerca in corso ...</h5>
          <div class="spinner"></div>
        </div>

        <div class="mt-5">
          <button :disabled="immobili" v-if="showButton" type="button"
                  class="text-center mt-2 btn btn-success  shadow-none abtg-button-big"
                  @click="getImmobili()">Visualizza Immobili
          </button>
        </div>
      </div>


      <div v-if="immobili === 'Nessun risultato per questo indirizzo.'" class="p-2">
        <h3 style="color: red" class="bold">{{immobili}}</h3>
      </div>

      <div v-for="(immobile, index) in immobili" class="mt-5" style="padding-right: 120px" v-if="!statoRichiesta && !isString(immobili)">
        <h4 class="bold">Immobile {{index + 1}}</h4>
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Indirizzo</th>
            <th>Foglio</th>
            <th>Categoria</th>
            <th>Particella</th>
            <th>Subalterno</th>
            <th>Zona Censuaria</th>
            <th>Categoria</th>
            <th>Classe</th>
            <th>Consistenza</th>
            <th>Rendita</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td>{{ immobile.indirizzo }}</td>
            <td>{{ immobile.foglio }}</td>
            <td>{{ immobile.categoria }}</td>
            <td>{{ immobile.particella }}</td>
            <td>{{ immobile.subalterno }}</td>
            <td>{{ immobile.zona_censuaria }}</td>
            <td>{{ immobile.categoria }}</td>
            <td>{{ immobile.classe }}</td>
            <td>{{ immobile.consistenza }}</td>
            <td>{{ immobile.rendita }}</td>
          </tr>
          </tbody>
        </table>
        <button
            class="text-center mt-2 btn btn-success abtg__btn-third shadow-none abtg-button-big" type="button"
            @click="queryVisura(immobile.id_immobile)">Richiedi una visura per questo immobile
        </button>
      </div>


      <div v-if="statoRichiesta">
        <h4 v-if="statoRichiesta === 'in_erogazione'" class="bold mt-5 p-2 text-success">Richiesta in erogazione, la
          riceverai tramite email entro 15 minuti.</h4>
        <h4 v-else class="bold mt-5 text-danger p-2">C'è stato un problema nella richiesta della visura, riprova tra 10
          minuti.</h4>
      </div>

    </div>

  </div>
</template>

<script>
import NBread from '@/partials/bread';
import City from './partials/city.vue';
import {mapActions, mapState, mapMutations} from 'vuex';
import {isString} from "lodash/lang";

export default {
  components: {
    NBread,
    City
  },
  computed: {
    ...mapState('n_track', ['versionData', 'bread_active', 'bread_list']),
  },
  data() {
    return {
      prov: null,
      comune: null,
      indirizzo: null,
      errorCom: null,
      startCiv: 1,
      endCiv: 2,
      queryId: null,
      showButton: false,
      searching: false,
      immobili: null,
      statoRichiesta: null
    }
  },
  created() {
    this.SET_DATA({name: 'bread_active', data: {label: 'Servizio di visure catastali'}});
    this.versionList();
  },
  methods: {
    isString,
    ...mapActions('n_track', ['versionList']),
    ...mapMutations('n_track', ['SET_DATA']),


    getAddress() {
      this.immobili = null;
      this.showButton = false;

      if (!this.comune || !this.indirizzo) {
        this.errorCom = 'Comune e indirizzo sono campi obbligatori.';
        return;
      }

      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.post('/api/v2/catasto/address', {
        prov: this.prov,
        comune: this.comune,
        indirizzo: this.indirizzo,
        startCiv: this.startCiv,
        endCiv: this.endCiv
      })
          .then(response => {
            this.queryId = response.data;
            this.errorCom = null;
            if (this.queryId === 'Indirizzo non valido.') {
              this.errorCom = 'Indirizzo non valido.';
            } else
              this.searching = true;
            setTimeout(() => {
              this.showButton = true;
              this.searching = false;
            }, 50000);
          })
          .catch(error => {
            this.errorSales = 'Servizio momentaneamente non disponibile, debug: ' + error.message;
          });
    },


    getImmobili() {
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.get('/api/v2/catasto/getImmobili/' + this.queryId)
          .then(response => {
            this.immobili = response.data;
          })
    },

    queryVisura(payload) {
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.get('/api/v2/catasto/visura/' + payload)
          .then(response => {
            this.statoRichiesta = response.data;
            this.showButton = false
          })
    }

  },
}
</script>

<style scoped>
.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>